import React from 'react';
import {Grid, Typography} from '@material-ui/core';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import moment from 'moment';
import {PBold} from 'components/TypographyShortcuts';

const useStyles = makeStyles(theme => ({
    fieldLabel: {
        fontWeight: 'bold',
        marginBottom: '0em',
    },
}));

const MMCdates = ({mmld}) => {
    const theme = useTheme();
    const classes = useStyles();
    if (mmld?.recent_mmld_meta) {
        const issueDate =
            mmld?.recent_mmld_meta
                .filter(docType => docType.DOCUMENT_TYPE === 'MMC')
                .map(issueDate => issueDate.DOCUMENT_ISSUED_DT) || {};
        const expireDate =
            mmld?.recent_mmld_meta
                .filter(docType => docType.DOCUMENT_TYPE === 'MMC')
                .map(expireDate => expireDate.DOCUMENT_EXPIRE_DT) || {};

        const renewalNotice =
            moment(expireDate, 'YYYY-MM-DDT...').add(1, 'y').isAfter() &&
            moment(expireDate, 'YYYY-MM-DDT...').isBefore();

        const expiredNotice = moment(expireDate, 'YYYY-MM-DDT...')
            .add(1, 'y')
            .isBefore();

        return (
            <Grid item>
                <PBold align='center'>
                    Merchant Mariner Credential Issue Date
                </PBold>
                <Typography variant='body1' align='center'>
                    {moment(issueDate, 'YYYY-MM-DDT...').format('MMM DD, YYYY')}
                </Typography>
                <PBold align='center'>
                    Merchant Mariner Credential Expiration Date
                </PBold>
                <Typography variant='body1' align='center'>
                    {moment(expireDate, 'YYYY-MM-DDT...').format(
                        'MMM DD, YYYY'
                    )}
                </Typography>
                {renewalNotice === true && (
                    <Grid
                        item
                        style={{
                            border: 'solid 1px',
                            borderRadius: '0.5em',
                            padding: '1em',
                            margin: '1em',
                            backgroundColor: theme.palette.charts.lightOrange,
                        }}
                    >
                        <Typography
                            variant='body1'
                            align='center'
                            className={classes.fieldLabel}
                        >
                            <PBold>
                                Your Credential is Expired, but still within the
                                1 year grace period to Renew. You have until{' '}
                                {moment(expireDate, 'YYYY-MM-DDT...')
                                    .add(1, 'y')
                                    .format('MMM DD, YYYY')}{' '}
                                to Renew.
                            </PBold>
                        </Typography>
                    </Grid>
                )}
                {expiredNotice === true && (
                    <Grid
                        item
                        style={{
                            border: 'solid 1px',
                            borderRadius: '0.5em',
                            padding: '1em',
                            margin: '1em',
                            backgroundColor: theme.palette.charts.lightOrange,
                        }}
                    >
                        <Typography
                            variant='body1'
                            align='center'
                            className={classes.fieldLabel}
                        >
                            <PBold>Your Credential is Expired</PBold>
                        </Typography>
                    </Grid>
                )}
            </Grid>
        );
    } else {
        return <div>no data yet</div>;
    }
};

export default MMCdates;
